import React from "react";
import Particles from "react-particles";
import "bulma/css/bulma.css";
import polygonConfig from "../config/polygonConfig";
import { loadFull } from "tsparticles";
import { useCallback } from "react";
export default function Ploygon() {
  const particlesInit = useCallback(async (engine) => {
    //console.log(engine);
    // you can initiate the tsParticles instance (engine) here, adding custom shapes or presets
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
    // starting from v2 you can add only the features you need reducing the bundle size
    await loadFull(engine);
  }, []);

  const particlesLoaded = useCallback(async (container) => {
    await console.log("");
  }, []);
  return (
    <Particles
      id="particles-js"
      className="particles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={polygonConfig}
    ></Particles>
  );
}
